const SAFE_COLOR = /^#[0-9a-f]{6}$/i

function text(value) {
  return value === null || value === undefined ? '' : String(value)
}

export function chamadaSignature(paciente) {
  if (!paciente || typeof paciente !== 'object') return ''

  const values = [
    text(paciente.paciente),
    text(paciente.departamento),
    text(paciente.sala),
    text(paciente.data_hora)
  ]
  return values.every((value) => value === '') ? '' : JSON.stringify(values)
}

export function normalizeSnapshot(value) {
  if (!Array.isArray(value)) return null
  if (value.some((item) => !item || typeof item !== 'object' || Array.isArray(item))) {
    return null
  }

  const occurrences = new Map()

  return value
    .map((item) => {
      const normalized = {
        ...item,
        paciente: text(item.paciente),
        departamento: text(item.departamento),
        sala: text(item.sala),
        data_hora: text(item.data_hora),
        classificacao_risco: SAFE_COLOR.test(text(item.classificacao_risco))
          ? text(item.classificacao_risco).toUpperCase()
          : '#FFFFFF'
      }
      const signature = chamadaSignature(normalized)
      const occurrence = occurrences.get(signature) || 0
      occurrences.set(signature, occurrence + 1)

      return {
        ...normalized,
        _key: `${signature}#${occurrence}`
      }
    })
}

export function samePainel(left, right) {
  const leftNumber = Number(left)
  const rightNumber = Number(right)

  return Number.isFinite(leftNumber) &&
    Number.isFinite(rightNumber) &&
    leftNumber === rightNumber
}

export function sameChamadaKey(item, current) {
  return Boolean(item?._key && current?._key && item._key === current._key)
}

export function isPainelCodigoValido(value) {
  return typeof value === 'string' && /^\d+$/.test(value)
}

export function canApplySync(startGeneration, currentGeneration) {
  return startGeneration === currentGeneration
}
